export interface PortalNotification {
  id?: number; // Option[Int] = None,
  name: string; // String,
  resellerId?: number; // Option[Int],
  type: PortalNotificationType; // PortalNotificationType.Value,
  recipient: PortalNotificationRecipient; // PortalNotificationRecipient.Value,
  recipients?: string[]; // Option[Seq[String]],
  important: boolean; // Boolean = false,
  sendMail: boolean; // Boolean = false,
  showToAll: boolean; // Boolean = true,
  expiresAt?: string; // Option[DateTime] = None,
  publishedAt?: string; // Option[DateTime] = None,
  beginAt?: string; // Option[DateTime] = None,
  endAt?: string; // Option[DateTime] = None,
  createdOn?: string; // Option[DateTime] = None,
  updatedOn?: string; // Option[DateTime] = Some(DateTime.now())
  updatedBy: string; // String
}

export enum PortalNotificationType {
  GENERAL = 'GENERAL',
  MAINTENANCE = 'MAINTENANCE',
  RELEASE_NOTES = 'RELEASE_NOTES',
}

export enum PortalNotificationRecipient {
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  ENTERPRISE = 'ENTERPRISE',
}
